import {
  IEmployee,
  IEmployeeSearch,
  IEmployeeSearchInternal,
} from 'src/models/employee.model';
import { actionTypes, IEmployeeState } from 'src/ducks/employee.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getEmployeeStatus = (
  state: IEmployeeState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };

export const getEmployeeOptions = (
  data: Partial<IEmployee>[],
  valueField: keyof IEmployee = 'emp_no'
) =>
  data.map((value) => ({
    key: value.emp_no,
    text: `${value.first_name} ${value.last_name} (${value.emp_no}) `,
    value: value[valueField],
  }));

export const getParsedEmployee = (employee: IEmployeeSearch): IEmployee => ({
  emp_no: employee.EMPNO ?? '',
  first_name: employee.FIRST_NAME,
  last_name: employee.LAST_NAME,
  e_mail_address: employee.E_MAIL_ADDRESS,
  job_title: employee.JOB_TITLE ?? '',
  company_name: employee.COMPANY_NAME ?? '',
  dept_org_desc: employee.DEPT_ORG_DESC ?? '',
  work_phone_1: employee.WORK_PHONE_1 ?? '',
  mgr_first_name: employee.MGR_FIRST_NAME ?? '',
  mgr_last_name: employee.MGR_LAST_NAME ?? '',
  mgr_e_mail_address: employee.MGR_E_MAIL_ADDRESS ?? '',
});

export const getParsedEmployeeInternal = (
  employee: IEmployeeSearchInternal
): IEmployee => ({
  emp_no: employee.empNo ?? '',
  first_name: employee.firstName,
  last_name: employee.lastName,
  middle_name: employee.middleName,
  e_mail_address: employee.emailAddress ?? '',
  company_name: employee.companyName ?? '',
});
